export const EXPEDIENTE_ACTION_VIEWS = {
  route: 'tickets',
  price_tip: 'market',
  story: 'journal',
};

export const EXPEDIENTE_ACTION_LABELS = {
  route: 'OPEN TICKETS',
  price_tip: 'OPEN MARKET',
  story: 'OPEN RECORD',
};

export const EXPEDIENTE_STATE_LABELS = {
  new: 'NEW',
  read: 'READ',
  acted: 'ACTED',
  expired: 'EXPIRED',
};

const KNOWN_VIEWS = new Set(['tickets', 'market', 'journal', 'story']);

export function expedienteStateLabel(state) {
  return EXPEDIENTE_STATE_LABELS[state] || 'UNFILED';
}

export function expedienteActionLabel(entry) {
  return EXPEDIENTE_ACTION_LABELS[entry?.actionKind] || 'OPEN';
}

/**
 * The server owns the action target; the client only follows its payload.
 * A missing or unknown target falls back to the action kind mapping.
 */
export function expedienteActionView(entry) {
  const payloadView = entry?.actionPayload?.view;
  if (KNOWN_VIEWS.has(payloadView)) {
    return payloadView === 'story' ? 'journal' : payloadView;
  }
  return EXPEDIENTE_ACTION_VIEWS[entry?.actionKind] || null;
}

export function expedienteEntryActionable(entry, { loading = false } = {}) {
  if (loading) return false;
  if (!entry || entry.state === 'acted' || entry.state === 'expired') return false;
  return Boolean(expedienteActionView(entry));
}

export function expedienteActionHint(entry) {
  const payload = entry?.actionPayload || {};
  return payload.hint || payload.districtName || payload.assetId || '';
}

export function expedienteSortEntries(entries) {
  return [...(Array.isArray(entries) ? entries : [])].sort((a, b) => {
    const day = Number(b?.dayIndex ?? 0) - Number(a?.dayIndex ?? 0);
    if (day !== 0) return day;
    return String(a?.entryId || '').localeCompare(String(b?.entryId || ''));
  });
}

export function mergeExpedienteEntry(entries, entry) {
  if (!entry) return Array.isArray(entries) ? entries : [];
  const list = Array.isArray(entries) ? entries : [];
  const found = list.some((row) => row.entryId === entry.entryId);
  if (!found) return [...list, entry];
  return list.map((row) => (row.entryId === entry.entryId ? { ...row, ...entry } : row));
}
